
import { Vue } from "vue-class-component";
import LayoutService from "../../../services/layout.service";
import { CustomDialog } from "../../../model/CustomDialog.model";
export default class IziDialog extends Vue {
  dialog: CustomDialog = {
    show: false,
    name: "",
    header: "",
    modal: false
  };
  created() {
    LayoutService.getDialog.subscribe((result: CustomDialog) => {
      this.dialog = { ...result };
    });
  }
  close() {
    this.dialog.show = false;
  }
}
